import { FC } from "react";
import ThemeProvider from "@/pages/routing/providers/theme.provider";
import {
  SidebarProvider,
  SidebarTrigger,
  SidebarInset,
} from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { Outlet } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Breadcrumbs } from "@/components/breadcrumbs";
import { PageTitleProvider, usePageTitle } from "@/components/page-title";

const LayoutContent: FC = () => {
  const { pageTitle } = usePageTitle();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="bg-background">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mr-2 data-[orientation=vertical]:h-4"
          />
          <Breadcrumbs customTitle={pageTitle || undefined} />
        </header>
        <main className="flex-1">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

const Layout: FC = () => {
  return (
    <ThemeProvider>
      <PageTitleProvider>
        <LayoutContent />
      </PageTitleProvider>
    </ThemeProvider>
  );
};

export default Layout;
